/* 
Copyright (c) Karsten Jeske and John Firth
This source code is licensed under the proprietary license found in the
LICENSE file in the root directory of this source tree.
*/

import ErrorModal from "components/ErrorModal"
import { UserParameters, userParametersSchema } from "features/userParameters/UserParametersSchema"
import { useState } from "react"
import { useFormContext } from "react-hook-form"
import { downloadWorkbook } from "services/workbooks/v1/workbookBuilding"

const XlsxDownload = () => {
  const { getValues } = useFormContext<UserParameters>()
  const [isDownloading, setIsDownloading] = useState(false)
  const [downloadError, setDownloadError] = useState<string | string[] | null>(null)

  const handleDownload = () => {
    setIsDownloading(true)
    setDownloadError(null)

    try {
      const formValues = getValues()
      const result = userParametersSchema.safeParse(formValues)

      if (!result.success) {
        setDownloadError("Please fix form errors before downloading parameters file.")
        return
      }

      downloadWorkbook(result.data)
    } catch (error) {
      // console.error("Error creating XLSX file:", error)
      setDownloadError(error instanceof Error ? error.message : "Unknown error creating file")
    } finally {
      setIsDownloading(false)
    }
  }

  return (
    <div>
      <div className="d-flex align-items-center">
        <button
          type="button"
          className="btn btn-secondary mt-3"
          onClick={handleDownload}
          disabled={isDownloading}
        >
          Save
        </button>

        {isDownloading && (
          <div className="spinner-border spinner-border-sm ms-2" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        )}
      </div>

      <ErrorModal
        show={!!downloadError}
        title="Error Downloading File"
        errorMessages={downloadError ?? ""}
        onClose={() => {
          setDownloadError(null)
        }}
      />
    </div>
  )
}

export default XlsxDownload
